import React, { useState, useEffect } from "react";
import Server, { requestERPLYData } from "../api/Server";
import { distributionReportFormData } from "../App";
import FilterSelector from "../components/central-distributions-reports/FilterSelector";
import Title from "../components/common/Title";
import { useAuth } from "../context/authContext";
import notify from "devextreme/ui/notify";
import {
  findRegionWarehousesAndMerge,
  formatProductResponse,
} from "../utils/index";
import { alert } from "devextreme/ui/dialog";
import DistributionTable from "../components/central-distributions-reports/DistributionTable";

export let distributedData = [];

const DistributionReport = () => {
  const [reportStore, setReportStore] = useState([]);
  const [open, setOpen] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedItems, setSelectedItem] = useState([]);
  const [isSelected, setIsSelected] = useState(false);
  const [productsList, setProducts] = useState([]);
  const [isEmpty, setIsEmpty] = useState(false);
  const [searchString, setSearchString] = useState("");
  const [autoCreateAmount, setAutoCreate] = useState(true);
  const [storeRegionWarehouses, setRegionWare] = useState([]);
  const [newFilters, setNewFilters] = useState({
    toLocationsWithReorderPointOnly: false,
    ignoreAssortments: false,
    useReorderMultiplesInSuggestedAmounts: false,
  });

  const { user } = useAuth();

  useEffect(() => {
    let handle;
    if (isLoading) {
      handle = setInterval(() => getReport(true), 9000);
    } else {
      if (handle) {
        clearInterval(handle);
      }
    }

    if (handle) {
      return () => {
        clearInterval(handle);
      };
    }
    // eslint-disable-next-line
  }, [isLoading]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    getReport();
  };

  const getStoreRegionWarehouses = async (id) => {
    try {
      const requestData = {
        request: "getWarehouses",
        storeRegionID: id,
        clientCode: user.clientCode,
      };
      if (user && (user.isIframe || user.sessionKey)) {
        requestData.sessionKey = user.sessionKey;
      }

      const { data } = await requestERPLYData(requestData);

      if (data.status.responseStatus !== "error") {
        setRegionWare(data.records);
      }
    } catch (error) {}
  };

  const onValueChanged = (event, name) => {
    const { value } = event;

    if (name === "searchString") {
      if (value === "") {
        setProducts([]);
        setIsEmpty(false);
        setIsSelected(true);
        setSearchString(value);
        return;
      } else {
        const request = {
          clientCode: user.clientCode,
          searchNameIncrementally: value,
          request: "getProducts",
          lang: user.lang,
        };

        if (user && (user.isIframe || user.sessionKey)) {
          request.sessionKey = user.sessionKey;
        }

        Server.searchNameIncrementally(request)
          .then((response) => {
            if (response.data.status.responseStatus === "error") {
              notify("Error getting product. Please try again", "error", 3000);
            } else {
              setProducts(formatProductResponse(response.data.records));

              setIsSelected(false);
              setIsEmpty(false);
            }
          })
          .catch((err) => {
            notify("Error getting product. Please try again", "error", 3000);
          });
        setSearchString(value);
      }
    } else {
      setAutoCreate(value);
    }
  };

  const onItemDeleted = (e) => {
    const { itemData } = e;
    const selected = [...selectedItems];
    const filtered = selected.filter(
      (item) => item.productID !== itemData.productID
    );

    if (filtered.length === 0) {
      setIsEmpty(true);
    }

    setSelectedItem(filtered);
  };

  const onSelectedItemsChange = (args) => {
    if (args.name === "selectedItems") {
      if (args.value.length === 0) return;

      const isExiting = selectedItems.find(
        (item) => item.productID === args.value[0].productID
      );

      if (isExiting) return;

      setSelectedItem([...selectedItems, args.value[0]]);

      setIsSelected(true);
      setSearchString("");
    }
  };

  const getReport = async (secondCall) => {
    const {
      sourceLocation,
      destinationLocation,
      productCategories,
      productGroups,
      brands,
      suppliers,
      storeRegion,
      reportType,
      orderBy,
      orderDirection,
    } = distributionReportFormData;

    if (!sourceLocation) {
      alert("Source location is required", "Notification");
      return;
    }

    if (!destinationLocation.length && !storeRegion) {
      alert("Destination location or Store region is required", "Notification");
      return;
    }

    if (!reportType) {
      alert(
        "Type of documents created by the report is required",
        "Notification"
      );
      return;
    }

    if (
      destinationLocation.length === 1 &&
      destinationLocation[0] === sourceLocation &&
      !storeRegion
    ) {
      alert(
        "Destination location should be different from Source location",
        "Notification"
      );
      return;
    }

    if (
      !destinationLocation.length &&
      storeRegion &&
      !storeRegionWarehouses.length
    ) {
      alert(
        "The Store region selected does not have any warehouse. Please add a warehouse to the store region or select another store region",
        "Notification"
      );
      return;
    }

    let toLocationIDs = "";
    if (storeRegion && storeRegionWarehouses.length) {
      toLocationIDs = findRegionWarehousesAndMerge(
        storeRegionWarehouses,
        destinationLocation,
        sourceLocation
      );
      if (!toLocationIDs) {
        alert(
          "The Store region selected does not have any warehouse or destination location selected is same as source location",
          "Notification"
        );
        return;
      }
    } else {
      if (destinationLocation.includes(sourceLocation)) {
        toLocationIDs = destinationLocation
          .filter((e) => e !== sourceLocation)
          .toString();
      } else {
        toLocationIDs = destinationLocation.map((e) => e).toString();
      }
    }

    if (!toLocationIDs && storeRegion) {
      alert(
        "The Store region selected does not have any warehouse or destination location selected is same as source location",
        "Notification"
      );
      return;
    }

    if (!secondCall) {
      setOpen(false);
    }

    let regenerate = true;
    if (secondCall) {
      regenerate = false;
    }
    const params = {
      fromLocationID: sourceLocation,
      toLocationIDs,
      useAutofill: autoCreateAmount,
      regenerate,
      orderBy,
      orderDirection,
    };

    if (productCategories.length) {
      params.productCategoryIDs = productCategories.map((e) => e).toString();
    }

    if (productGroups.length) {
      params.productGroupIDs = productGroups.map((e) => e).toString();
    }

    if (brands.length) {
      params.brandIDs = brands.map((e) => e).toString();
    }

    if (suppliers.length) {
      params.supplierIDs = suppliers.map((e) => e).toString();
    }

    if (selectedItems.length) {
      params.productIDs = selectedItems
        .map((product) => product.productID)
        .toString();
    }

    if (newFilters.ignoreAssortments) {
      params.ignoreAssortments = newFilters.ignoreAssortments;
    }

    if (newFilters.toLocationsWithReorderPointOnly) {
      params.toLocationsWithReorderPointOnly =
        newFilters.toLocationsWithReorderPointOnly;
    }

    if (newFilters.useReorderMultiplesInSuggestedAmounts) {
      params.useReorderMultiplesInSuggestedAmounts =
        newFilters.useReorderMultiplesInSuggestedAmounts;
    }

    try {
      setIsLoading(true);
      const { data } = await Server.getDistributionReport(params);

      if (data.data.status === "READY") {
        // console.log(data.data.report);
        setReportStore(data.data.report);
        distributedData = data.data.report;
        setIsLoading(false);
      }
    } catch (err) {
      if (err.response) {
        const {
          response: { data },
        } = err;
        if (data) {
          notify(`${data.status.errorDescription}`, "error", 3000);
        } else {
          notify("Error getting reports data, please try again", "error", 3000);
        }
      } else {
        notify("Error getting reports data, please try again", "error", 3000);
      }

      setIsLoading(false);
    }
  };

  return (
    <div className='mt-4'>
      <Title pageTitle={"Central Distribution Report"} />
      <FilterSelector
        formData={distributionReportFormData}
        handleSubmit={handleSubmit}
        isSelected={isSelected}
        productsList={productsList}
        isEmpty={isEmpty}
        searchString={searchString}
        onValueChanged={onValueChanged}
        onItemDeleted={onItemDeleted}
        onSelectedItemsChange={onSelectedItemsChange}
        selectedItems={selectedItems}
        autoCreateAmount={autoCreateAmount}
        open={open}
        setOpen={setOpen}
        newFilters={newFilters}
        setNewFilters={setNewFilters}
        getStoreRegionWarehouses={getStoreRegionWarehouses}
      />
      {/* <CentralDisReport
        isLoading={isLoading}
        reportStore={reportStore}
        user={user}
        getReport={getReport}
      /> */}

      <DistributionTable
        reportStore={reportStore}
        isLoading={isLoading}
        user={user}
        getReport={getReport}
        reportType={distributionReportFormData.reportType}
      />
    </div>
  );
};

export default DistributionReport;
